<template>
    <div class="dashboard_wrapper">
        <div class="container_apps">
            <div
                class="box app_container_item"
                @click="gotoViewApp(app.app_solution)"
                v-for="(app,index) in translations.apps"
                :key="index"
                :data-src-image="app.backgroundImage"
            >
                <p class="title">{{ app.title }}</p>
                <p class="description">{{ app.description }}</p>
                <p class="version">
                    <span>{{ translations.dashboard.version }}</span>
                    {{ app.version }}
                </p>
                <a class="button_solution"
                    ><i class="icon-arrow-right-circle"></i
                ></a>
            </div>
        </div>
    </div>
</template>

<script>
import App from './../application'

export default {
    data: function () {
        App.setLanguage(App.selected_language);
        return {
            translations: {
                all: App.current_translations,
                apps: App.current_translations['apps'],
                generic: App.current_translations['generic'],
                dashboard: App.current_translations['dashboard'],
            }
        }
    },
    methods: {
        gotoViewApp: function (param) {
            // App.root_activated_view = param;
            this.$router.push('/query');
        }
    },
    mounted: function () {
        var apps_box = document.getElementsByClassName("app_container_item");
        for (var i = 0; i < apps_box.length; i++) {
            var srcImage = apps_box[i].dataset.srcImage;
            if (srcImage != null && srcImage != "") {
                var el = apps_box[i].style;
                el.backgroundImage = 'url(../' + srcImage + ')';
                el.backgroundSize = 'inherit';
                el.backgroundPosition = 'center right';
                el.backgroundRepeat = 'no-repeat';
            }
        }

        document.title = "UnexApp"
    }
}
</script>

<style>
</style>